<p>igxadaptor works!</p>
